export const REQUEST_COIN_STATS = 'REQUEST_COIN_STATS';
export const GET_COIN_STATS_SUCCESS = 'GET_COIN_STATS_SUCCESS';
export const GET_COIN_STATS_ERROR = 'GET_COIN_STATS_ERROR';

export const REQUEST_COIN_HISTORY = 'REQUEST_COIN_HISTORY';
export const GET_COIN_HISTORY_SUCCESS = 'GET_COIN_HISTORY_SUCCESS';
export const GET_COIN_HISTORY_ERROR = 'GET_COIN_HISTORY_ERROR';
